// removed by extract-text-webpack-plugin
module.exports = {"carouselImages":"qempo_CarouselPressNews_carouselImages-sZUAGZv","contentWrap":"qempo_CarouselPressNews_contentWrap-g6HRQtL","carousel":"qempo_CarouselPressNews_carousel-rE25yXb","arrowLeft":"qempo_CarouselPressNews_arrowLeft-16QvFqH","arrowRight":"qempo_CarouselPressNews_arrowRight-ZcmCcQO"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/CarouselPressNews/CarouselPressNews.scss
// module id = 2297
// module chunks = 0